import { useMutation } from '@apollo/client';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { gql } from '__generated__';
import { FC } from 'react';

import { FormInput, FormPanel } from 'components/FormPanel';

const UPDATE_Division_MUTATION = gql(`
  mutation UpdateDivision($id: ID!, $name: String!, $shortName: String) {
    updateDivision(id: $id, name: $name, shortName: $shortName) {
      id
      name
      shortName
      createdAt
      updatedAt
    }
  }
`);

const UpdateDivisionDialog: FC<{
  id: string;
  name: string;
  shortName?: string;
  onClose: () => void;
}> = ({ id, name, shortName, onClose }) => {
  const [updateDivision, { loading, error }] = useMutation(UPDATE_Division_MUTATION, {
    onCompleted: onClose,
  });

  return (
    <>
      <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>Update Division</DialogTitle>
        <DialogContent sx={{ minHeight: '50vh' }}>
          <FormPanel
            loading={loading}
            error={error}
            onCancel={onClose}
            onSubmit={data => {
              updateDivision({
                variables: {
                  id,
                  name: data.name,
                  shortName: data.shortName,
                },
              });
            }}
          >
            <FormInput
              fullWidth
              type="string"
              fieldName="name"
              label="Name"
              defaultValue={name}
              validators={{
                required: true,
              }}
            />
            <FormInput
              fullWidth
              type="string"
              fieldName="shortName"
              label="Short Name"
              defaultValue={shortName || ''}
            />
          </FormPanel>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UpdateDivisionDialog;
